require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./doloremque-delectus-exercitationem-iusto-quis-voluptates.json") })
        }
      }, "path---doloremque-delectus-exercitationem-iusto-quis-voluptates");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---doloremque-delectus-exercitationem-iusto-quis-voluptates!./.cache/json/doloremque-delectus-exercitationem-iusto-quis-voluptates.json
// module id = 393
// module chunks = 231608221292675